var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,attrs:{"disabled":_vm.disabled}},[(_vm.$slots.icon)?[_vm._t("icon"),_vm._v(" "+_vm._s(_vm.text)+" ")]:(_vm.$slots.default)?_vm._t("default"):[_vm._v(" "+_vm._s(_vm.text)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }